import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import "./index.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import UserContextProvider from "./context/userContextProvider"
import DataContextProvider from "./context/dataContextProvider"
import { MathJaxContext } from "better-react-mathjax"
// import PrelineScript from "./utils/prelineScript"

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <UserContextProvider>
        <DataContextProvider>
          <MathJaxContext>
            {/* <PrelineScript /> */}
            {/* <NavModal /> */}
            <App />
          </MathJaxContext>
        </DataContextProvider>
      </UserContextProvider>
    </BrowserRouter>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
